/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Manager_Delivery_SlaInputs */

const vi_dashboard_manager_delivery_sla = /** @type {(inputs: Dashboard_Manager_Delivery_SlaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiệu suất giao hàng tháng này`)
};

/**

* @param {Dashboard_Manager_Delivery_SlaInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const dashboard_manager_delivery_sla = /** @type {((inputs?: Dashboard_Manager_Delivery_SlaInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Manager_Delivery_SlaInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_dashboard_manager_delivery_sla(inputs)
});